import { isEmpty, checkSpecialCharacter, checkChar, checkDigit } from '../../libs/validation/validators'
export default function validateAuth(values) {
  let errors = {};
  Object.keys(values).map(key => {
    switch (key) {
     
      case "newpassword":
        if (isEmpty(values.newpassword)) {
          errors.newpassword = "New Password cannot be left blank";
        } else if (!isEmpty(values.newpassword)) {
          if (values.newpassword.length < 8 || !checkSpecialCharacter(values.newpassword) || !checkChar(values.newpassword) || !checkDigit(values.newpassword)) {
            errors.newpassword = "Your New Password needs to have at least 8 characters, 1 special character and 1 number";
          } 
        }
        break;
        
      case "confirmpassword":
        if (isEmpty(values.confirmpassword)) {
          errors.confirmpassword = "Confirm Password cannot be left blank";
        } else if (!isEmpty(values.confirmpassword)) {
          if (values.newpassword !== undefined) {
            if (values.confirmpassword !== values.newpassword) {
              errors.confirmpassword = "New Password and Confirm Password do not match.";
            }
          }
        }
        break;
    }
  });
  console.log(errors)
  return errors;
}
